import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export interface Crumb {
  label: string;
  to?: string;
}

export function Breadcrumb({ items }: { items: Crumb[] }) {
  if (items.length === 0) return null;
  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-body-sm text-on-surface-variant">
      {items.map((c, i) => {
        const last = i === items.length - 1;
        return (
          <Fragment key={i}>
            {c.to && !last ? (
              <Link to={c.to} className="hover:text-on-surface">
                {c.label}
              </Link>
            ) : (
              <span className={last ? 'font-medium text-on-surface' : undefined}>{c.label}</span>
            )}
            {!last && <ChevronRight className="h-3.5 w-3.5" />}
          </Fragment>
        );
      })}
    </nav>
  );
}
